import * as React from "react";
import EditBillerContainer from "../../BillerCategories/EditBillerContainer";
import { match } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

type Props = {
  match: match<{ id: string }>;
  setHeader: (data: { title: string; description: string }) => void;
  getBiller: any;
};

class BillerEdit extends React.Component<Props, any> {
  componentDidMount() {
    this.props.setHeader({
      title: "Ops > BillerCategories",
      description: "SnapScan Biller Info",
    });
  }

  render() {
    const biller =
      this.props.getBiller.billers && this.props.getBiller.billers.length > 0
        ? this.props.getBiller.billers[0]
        : null;
    return (
      <div>
        <section className="padded scrollable">
          <EditBillerContainer
            biller={biller}
            refetch={this.props.getBiller.refetch}
          />
        </section>
      </div>
    );
  }
}

const getBillerQuery = graphql<any, Props>(
  gql`
    query billers($id: ID) {
      billers(id: $id) {
        id
        identifier
        provider
        name
        placeholder
        logo
        updated_at
        category_list
      }
    }
  `,
  {
    name: "getBiller",
    options(props: any) {
      return {
        variables: {
          id: props.match.params.id,
        },
      };
    },
  }
);

export default compose<any>(getBillerQuery)(BillerEdit);
